import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

export default async function classbookRedirect ({ to, store }) {
  if (!to.params.id) {
    if (to.name === 'classbook-entity-details') return
    return {
      name: 'classbook-entity-details',
      params: { ...to.params, entity: to.params.entity },
      query: { ...to.query }
    }
  }

  const entityPermissions = store.getters['classbook/ENTITY_PERMISSIONS']
  if (!entityPermissions) return

  const getFirstAllowedTab = (permissions) => {
    if (!permissions) return 'classbook-entity-details-entries'
    // the order is relevant. the first allowed tab should be returned.
    const perms = [
      { can: 'view-entries', queryName: 'classbook-entity-details-entries' },
      { can: 'view-notices', queryName: 'classbook-entity-entries-comments' },
      { can: 'view-homeworks', queryName: 'classbook-entity-entries-homework' },
      { can: 'view-absences', queryName: 'classbook-entity-details-absences' }
    ]
    return perms.find((perm) => permissions[perm.can])?.queryName
  }

  /* redirect if permissions are not given */
  if (!GlobalPrototypes.can(to.meta.can, { can: entityPermissions })) {
    return {
      replace: true,
      name: getFirstAllowedTab(entityPermissions),
      params: { ...to.params },
      query: { ...to.query }
    }
  }
}
